import { render, staticRenderFns } from "./help-menu.vue?vue&type=template&id=e0ddfb9a&"
import script from "./help-menu.vue?vue&type=script&lang=js&"
export * from "./help-menu.vue?vue&type=script&lang=js&"
import style0 from "./_help-menu.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports